import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import UnderConstruction from "./UnderConstruction";
const Reach = () => {
    const url = "https://reach.livetiles.io/";
    return (_jsx(UnderConstruction, { buttonLink: url, buttonText: "Go to Reach" }));
};
export default Reach;
